export function search(content, bulletinData) {
	if (bulletinData === null) return [];
	else if (!content | (content === '')) return Object.keys(bulletinData);

	let results = [];

	for (const bulletin in bulletinData) {
		if (bulletinData[bulletin]?.title?.includes(content)) results.push(bulletin);
		else if (bulletinData[bulletin]?.org?.includes(content)) results.push(bulletin);
		else if (dateToString(bulletinData[bulletin]?.date).includes(content))
			results.push(bulletin);
		else
			for (const det of bulletinData[bulletin]?.det) {
				const detKey = Object.keys(det)[0];

				if (detKey?.includes(content)) {
					results.push(bulletin);
					break;
				} else if (det[detKey]?.toString().includes(content)) {
					results.push(bulletin);
					break;
				}
			}
	}

	return results;
}

function dateToString(dateTuple) {
	let dateString = '';
	dateString += dateTuple[0] ? `${dateTuple[0]}년` : '';
	dateString += dateTuple[1] ? ` ${dateTuple[1]}월` : '';
	dateString += dateTuple[2] ? ` ${dateTuple[2]}일` : '';

	return dateString;
}
